import { axiosInstance } from "../../../axios/axiosInstance";

const API_SERVICE_PROVIDERS_URL = "admin/organization";
const API_SERVICE_PROVIDERS_MODULE_LIST_URL =
  API_SERVICE_PROVIDERS_URL + "/list";
const API_UPDATE_SERVICE_PROVIDER_MODULE_STATUS_URL =
  API_SERVICE_PROVIDERS_URL + "/update-verification-status";
const API_SERVICE_PROVIDER_BY_ID_URL = API_SERVICE_PROVIDERS_URL + "/view";
const API_GET_SERVICE_PROVIDER_SERVICES_URL =
API_SERVICE_PROVIDERS_URL + "/get-org-services";
const API_GET_SERVICE_PROVIDER_OFFERS_URL =
API_SERVICE_PROVIDERS_URL + "/get-org-offers";
const API_GET_SERVICE_PROVIDER_PACKAGES_URL =
API_SERVICE_PROVIDERS_URL + "/get-org-packages";
const API_UPDATE_SERVICE_PROVIDER_SERVICES_STATUS_URL =
API_SERVICE_PROVIDERS_URL + "/update-service-status";
const API_UPDATE_STATUS_URL = API_SERVICE_PROVIDERS_URL + "/update-status";
const API_GET_STAFF_MEMBERS_LIST_BY_SERVICE_PROVIDER_ID_URL = API_SERVICE_PROVIDERS_URL + "/list_members";

export const getServiceProviders = (dataToBeSent) => {
  return axiosInstance.get(
    `${API_SERVICE_PROVIDERS_MODULE_LIST_URL}?page=${
      dataToBeSent?.page || ""
    }&limit=${dataToBeSent?.limit || ""}&search=${
      dataToBeSent?.search || ""
    }&country=${dataToBeSent?.country || ""}`
  );
};

export const getServiceProviderById = (dataToBeSent) => {
  return axiosInstance.get(
    API_SERVICE_PROVIDER_BY_ID_URL +
      "/" +
      dataToBeSent?.selectedServiceProviderId
  );
};

export const getStaffMemberByServiceProviderId = (dataToBeSent) => {
  return axiosInstance.get(`${API_GET_STAFF_MEMBERS_LIST_BY_SERVICE_PROVIDER_ID_URL + "/" + dataToBeSent?.selectedServiceProviderId}?page=${dataToBeSent?.page || ""}&limit=${dataToBeSent?.limit || ""}&search=${dataToBeSent?.search || ""}`);
};

export const updateServiceProviderStatus = ({
  selectedServiceProviderId,
  ...rest
}) => {
  return axiosInstance.post(
    API_UPDATE_SERVICE_PROVIDER_MODULE_STATUS_URL +
      "/" +
      selectedServiceProviderId,
    { ...rest }
  );
};

export const updateStatus = ({ selectedServiceProviderId, ...rest }) => {
  return axiosInstance.patch(
    API_UPDATE_STATUS_URL + "/" + selectedServiceProviderId,
    { ...rest }
  );
};

export const getServiceProviderServices = ({
  selectedOrganizationId,
  ...rest
}) => {
  return axiosInstance.get(
    `${API_GET_SERVICE_PROVIDER_SERVICES_URL}/${selectedOrganizationId}?page=${
      rest?.page || ""
    }&limit=${rest?.limit || ""}&search=${rest?.search || ""}`,
    { ...rest }
  );
};

export const getServiceProviderOffers = ({selectedOrganizationId,...rest}) => {
  return axiosInstance.get(`${API_GET_SERVICE_PROVIDER_OFFERS_URL}/${selectedOrganizationId}?page=${rest?.page || ""
    }&limit=${rest?.limit || ""}&search=${rest?.search || ""}`,{ ...rest });
};

export const getServiceProviderPackages = ({selectedOrganizationId,...rest}) => {
  return axiosInstance.get(`${API_GET_SERVICE_PROVIDER_PACKAGES_URL}/${selectedOrganizationId}?page=${rest?.page || ""
    }&limit=${rest?.limit || ""}&search=${rest?.search || ""}`,{ ...rest });
};

export const updateOrganizationServicesStatus = ({
  selectedOrganizationId,
  ...rest
}) => {
  return axiosInstance.patch(
    API_UPDATE_SERVICE_PROVIDER_SERVICES_STATUS_URL +
      "/" +
      selectedOrganizationId,
    { ...rest }
  );
};
